import { produce } from 'immer';
import { getLocalStorage, removeData } from '../../utility/LocalStorage';
import Workspaces from '../../workspaces';
import { addWorkspace } from './actions/addWorkspace';
import { initPreferences } from './actions/initPreferences';
import { removeWorkspace } from './actions/removeWorkspace';
import { setPanelsPreferences } from './actions/setPanelsPreferences';
import { setPreferences } from './actions/setPreferences';
import { setWorkspace } from './actions/setWorkspace';
const LOCAL_STORAGE_VERSION = 10;
export const WORKSPACES = [
    {
        key: 'default',
        label: Workspaces.default.label,
    },
    {
        key: 'process1D',
        label: Workspaces.process1D.label,
    },
    {
        key: 'exercise',
        label: Workspaces.exercise.label,
    },
    {
        key: 'prediction',
        label: Workspaces.prediction.label,
    },
    {
        key: 'embedded',
        label: Workspaces.embedded.label,
    },
];
export const preferencesInitialState = {
    version: LOCAL_STORAGE_VERSION,
    workspaces: {},
    dispatch: () => null,
    workspace: {
        current: 'default',
        base: null,
    },
};
export function initPreferencesState(state) {
    const nmrLocalStorageVersion = getLocalStorage('nmr-local-storage-version', false);
    let localData = getLocalStorage('nmr-general-settings');
    // remove old nmr-local-storage-version key
    if (nmrLocalStorageVersion && localData?.version) {
        removeData('nmr-local-storage-version');
    }
    //  if the local setting version != current settings version number
    if (!localData?.version || localData?.version !== LOCAL_STORAGE_VERSION) {
        removeData('nmr-general-settings');
    }
    return {
        ...state,
        workspaces: localData?.workspaces || { default: Workspaces.default },
    };
}
function innerPreferencesReducer(draft, action) {
    switch (action.type) {
        case 'INIT_PREFERENCES':
            return initPreferences(draft, action);
        case 'SET_PREFERENCES':
            return setPreferences(draft, action);
        case 'SET_PANELS_PREFERENCES':
            return setPanelsPreferences(draft, action);
        case 'SET_WORKSPACE':
            return setWorkspace(draft, action);
        case 'ADD_WORKSPACE':
            return addWorkspace(draft, action);
        case 'REMOVE_WORKSPACE':
            return removeWorkspace(draft, action);
        default:
            return draft;
    }
}
const preferencesReducer = produce(innerPreferencesReducer);
export default preferencesReducer;
